/**
 * Dependencies.
 */
import { BaseModel, endpoint } from '@prz-dp/services';

/**
 * Export `StatusModel`.
 */
@endpoint('status')
export default class StatusModel extends BaseModel {
  /**
   * Properties.
   */
  code: string;

  name: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<StatusModel>) {
    super(data);
  }
}
